import { cn } from '@/utils/cn'
import type { ReactNode } from 'react'
import type { NavLinkProps } from 'react-router'
import { NavLink } from 'react-router'
import { Button } from './button'

interface MenuLinkSharedProps {
  icon: ReactNode
  label: string
  showLabel: boolean
  className?: string
  onClick?: () => void
}

const baseClassName = cn(
  'group flex h-11 items-center justify-start gap-2 rounded-xl px-6 transition-all',
  'hocus:text-accent focus-visible:ring-inset'
)

const MenuLinkInner = ({ icon, label, showLabel }: Pick<MenuLinkSharedProps, 'icon' | 'label' | 'showLabel'>) => (
  <>
    <span className="group-[.active]:text-accent">{icon}</span>
    <span
      className={cn(
        'whitespace-nowrap font-medium text-sm transition-opacity',
        showLabel ? 'opacity-100' : 'opacity-0'
      )}
    >
      {label}
    </span>
  </>
)

type MenuLinkProps = MenuLinkSharedProps & Omit<NavLinkProps, 'children' | 'onClick'>

export const MenuLink = ({ icon, label, showLabel, className, onClick, ...props }: MenuLinkProps) => (
  <Button variant="default" size="default" className={cn(baseClassName, className)} asChild>
    <NavLink onClick={onClick} {...props}>
      <MenuLinkInner icon={icon} label={label} showLabel={showLabel} />
    </NavLink>
  </Button>
)
